import React, { type ComponentType } from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const NinChangeboardingAdminModal = lazyForPaint<ComponentType<{}>>(
	() =>
		import(
			/* webpackChunkName: "async-issue-navigator-changeboarding-admin-modal" */ './admin-modal'
		),
	{ ssr: false },
);

export const AsyncNinChangeboardingAdminModal: ComponentType<{}> = () => (
	<JSErrorBoundary
		packageName="jiraIssueNavigatorChangeboarding"
		id="async-changeboarding-admin-modal"
		sendToPrivacyUnsafeSplunk
		fallback="unmount"
	>
		<NinChangeboardingAdminModal />
	</JSErrorBoundary>
);
